var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "auth-layout",
    { attrs: { pageClass: "login-page" } },
    [
      _c(
        "b-row",
        { staticClass: "d-flex justify-content-center align-items-center" },
        [
          _c("b-col", { attrs: { lg: "4", md: "6", sm: "8" } }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit($event)
                  }
                }
              },
              [
                _c(
                  "fade-render-transition",
                  [
                    _c("card", [
                      _c(
                        "div",
                        {
                          staticClass: "text-center",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c("h3", { staticClass: "card-title text-center" }, [
                            _vm._v("Reset Password")
                          ]),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-center" }, [
                            _vm._v("Please create your New Password")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("fg-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            ref: "password",
                            class: _vm.errors.has("password")
                              ? "is-invalid"
                              : "",
                            attrs: {
                              label: "Password",
                              placeholder: "Enter password",
                              type: "password",
                              autofocus: "",
                              name: "password"
                            },
                            model: {
                              value: _vm.model.password,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "password", $$v)
                              },
                              expression: "model.password"
                            }
                          }),
                          _vm._v(" "),
                          _c("fg-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|confirmed:password",
                                expression: "'required|confirmed:password'"
                              }
                            ],
                            class: _vm.errors.has("passwordConfirmation")
                              ? "is-invalid"
                              : "",
                            attrs: {
                              label: "Password Confirmation",
                              placeholder: "Password confirmation",
                              type: "password",
                              autofocus: "",
                              name: "passwordConfirmation"
                            },
                            model: {
                              value: _vm.model.passwordConfirmation,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "passwordConfirmation", $$v)
                              },
                              expression: "model.passwordConfirmation"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-fill btn-round btn-wd ",
                              attrs: { variant: "success", type: "submit" }
                            },
                            [
                              _vm.isLoading
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "spinner", spin: "" }
                                  })
                                : _vm._e(),
                              _vm._v(" Reset")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "forgot" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "card-category",
                                  attrs: { to: "/login" }
                                },
                                [
                                  _vm._v(
                                    "\n                  Back To Log In\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4bb6d26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4bb6d26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Auth/ResetPassword.vue
// module id = crtc
// module chunks = 4